import { render, staticRenderFns } from "./DetailCustomer.vue?vue&type=template&id=1e571437&"
import script from "./DetailCustomer.vue?vue&type=script&lang=js&"
export * from "./DetailCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports